import type { FunctionComponent, ReactElement } from 'react';
import { useCallback, useEffect } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { useSubtitlesSlice } from '../../../store/slices/subtitles/selectors';
import { subtitlesActions } from '../../../store/slices/subtitles/slice';
import { toastActions } from '../../../store/slices/toast/slice';
import { Toast } from '../../toast/Toast';
import type { ToastConnectedProps } from '../types';

export const SubtitlesClosedToastConnected: FunctionComponent<ToastConnectedProps> = ({
  message,
  timeStamp,
  ...rest
}): ReactElement => {
  const dispatch = useCoreDispatch();

  const onClose = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  const onUndo = useCallback((): void => {
    onClose();

    dispatch(subtitlesActions.setIsEnabled(true));
  }, [dispatch, onClose]);

  const isSubtitlesEnabled = useSubtitlesSlice.getIsEnabled();
  // Closes the toast when the player re-enables Subtitles from the Settings and the Undo timer is still running.
  useEffect(() => {
    if (isSubtitlesEnabled) {
      onClose();
    }
  }, [isSubtitlesEnabled, onClose]);

  const undoButton = {
    tk: 'TOAST_UNDO',
    onClick: onUndo,
  };

  return <Toast button={undoButton} message={message} onClose={onClose} {...rest} />;
};
